/* HER MARK — theme interactions
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var money = window.Shopify && Shopify.currency ? Shopify.currency.active : '';

  /* ---------- Smart sticky header (shadow + hide on scroll down) ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastY = window.scrollY;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (y > 320 && y > lastY + 4) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y <= 320) header.classList.remove('is-hidden');
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Hero entrance choreography ---------- */
  var vhero = document.querySelector('[data-vhero]');
  if (vhero) {
    setTimeout(function () { vhero.classList.add('is-in'); }, 120);
    var vid = vhero.querySelector('video');
    if (vid) {
      vid.muted = true;
      var tryPlay = function () {
        if (document.hidden) return;
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      };
      tryPlay();
      vid.addEventListener('canplay', tryPlay);
      document.addEventListener('visibilitychange', tryPlay);
    }
    var scrollBtn = vhero.querySelector('[data-scroll-next]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        var next = vhero.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  /* ---------- Generic drawer open/close ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-mobile-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () { openDrawer(mobileNav); });
  });
  if (mobileNav) {
    mobileNav.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeDrawer(mobileNav); });
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart();
      openDrawer(cartDrawer);
    });
  });
  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeDrawer(cartDrawer); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(mobileNav); closeDrawer(cartDrawer); }
  });

  /* ---------- Cart: fetch + render ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return '₪' + value;
  }

  function renderCart(cart) {
    var itemsEl = cartDrawer && cartDrawer.querySelector('[data-cart-items]');
    var footEl = cartDrawer && cartDrawer.querySelector('[data-cart-foot]');
    var totalEl = cartDrawer && cartDrawer.querySelector('[data-cart-total]');
    if (!itemsEl) return;

    // update all cart counts
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>העגלה שלך ריקה כרגע.</p></div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x120$1') : '';
      html += '' +
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          (img ? '<img class="cart-line__img" src="' + img + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '<div class="cart-line__img"></div>') +
          '<div>' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '') +
            '<div class="qty" style="margin-top:8px;transform:scale(0.85);transform-origin:right">' +
              '<button type="button" data-qty-down aria-label="הפחת">&minus;</button>' +
              '<input type="text" value="' + item.quantity + '" readonly aria-label="כמות">' +
              '<button type="button" data-qty-up aria-label="הוסף">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:end">' +
            '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove style="color:var(--color-charcoal-45);font-size:0.8rem;margin-top:8px;text-decoration:underline">הסר</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    bindCartLineEvents();
  }

  function bindCartLineEvents() {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('.qty input');
      line.querySelector('[data-qty-up]').addEventListener('click', function () {
        changeLine(key, parseInt(input.value, 10) + 1);
      });
      line.querySelector('[data-qty-down]').addEventListener('click', function () {
        changeLine(key, parseInt(input.value, 10) - 1);
      });
      line.querySelector('[data-line-remove]').addEventListener('click', function () {
        changeLine(key, 0);
      });
    });
  }

  function changeLine(key, qty) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'מוסיף…'; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.innerHTML = 'נוסף ✓'; }
        refreshCart();
        openDrawer(cartDrawer);
        setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1200);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      });
  });

  refreshCart();

  /* ---------- Reveal on scroll + stagger ---------- */
  document.querySelectorAll('[data-stagger]').forEach(function (wrap) {
    Array.prototype.forEach.call(wrap.children, function (child, i) {
      child.style.setProperty('--d', (i * 0.09) + 's');
    });
  });
  // Auto-stagger product/category/feature/review grids
  document.querySelectorAll('.product-grid, .cat-grid, .feature-grid, .review-grid').forEach(function (grid) {
    Array.prototype.forEach.call(grid.children, function (child, i) {
      child.style.setProperty('--d', ((i % 8) * 0.08) + 's');
    });
  });

  var revealEls = document.querySelectorAll('.reveal, [data-stagger]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Animated counters (about stats) ---------- */
  var counterWraps = document.querySelectorAll('[data-counters]');
  if ('IntersectionObserver' in window && counterWraps.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        entry.target.querySelectorAll('b').forEach(function (el) {
          var m = (el.textContent || '').trim().match(/^([\d.,]+)(.*)$/);
          if (!m) return;
          var target = parseFloat(m[1].replace(/,/g, ''));
          var suffix = m[2] || '';
          var decimals = (m[1].split('.')[1] || '').length;
          var start = null;
          function tick(ts) {
            if (!start) start = ts;
            var t = Math.min((ts - start) / 1400, 1);
            var eased = 1 - Math.pow(1 - t, 3);
            el.textContent = (target * eased).toFixed(decimals) + suffix;
            if (t < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      });
    }, { threshold: 0.4 });
    counterWraps.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq]').forEach(function (item) {
    var btn = item.querySelector('.faq__q');
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Before / After slider ---------- */
  document.querySelectorAll('[data-ba]').forEach(function (ba) {
    var range = ba.querySelector('.ba__range');
    if (!range) return;
    range.addEventListener('input', function () {
      ba.style.setProperty('--ba', range.value + '%');
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.removeAttribute('srcset'); // srcset overrides src — clear it so the image actually swaps
          main.removeAttribute('sizes');
          main.src = thumb.getAttribute('data-full');
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-plus]') && wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
    wrap.querySelector('[data-qty-minus]') && wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });

  /* ---------- Product page: variant switching + mobile buy bar ---------- */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse(pdp.parentNode.querySelector('[data-pdp-variants]').textContent); } catch (e) {}
    var idInput = pdp.querySelector('[data-pdp-id]');
    var priceBox = pdp.querySelector('[data-pdp-price]');
    var badge = pdp.querySelector('[data-pdp-badge]');
    var atc = pdp.querySelector('[data-pdp-atc]');
    var atcLabel = atc && atc.querySelector('span');
    var bar = document.querySelector('[data-pdp-bar]');
    var barPrice = bar && bar.querySelector('[data-pdp-bar-price]');
    var form = pdp.querySelector('.product__form');
    var optionSelects = pdp.querySelectorAll('[data-pdp-option]');

    function priceHtml(v) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        return '<span class="price price--sale">' + formatMoney(v.price) + '</span>' +
               '<s class="price--compare">' + formatMoney(v.compare_at_price) + '</s>';
      }
      return '<span class="price">' + formatMoney(v.price) + '</span>';
    }

    function currentVariant() {
      if (!optionSelects.length) return variants[0];
      var chosen = [];
      optionSelects.forEach(function (s) { chosen.push(s.value); });
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];
    }

    function updatePDP() {
      var v = currentVariant();
      if (!v) {
        if (atcLabel) atcLabel.textContent = 'לא זמין';
        if (atc) atc.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceBox) priceBox.innerHTML = priceHtml(v);
      if (barPrice) barPrice.textContent = formatMoney(v.price);
      if (badge) {
        if (v.compare_at_price > v.price) {
          var saved = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          badge.textContent = saved + '%- מבצע'; badge.style.display = '';
        } else { badge.style.display = 'none'; }
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? 'הוספה לעגלה' : 'אזל מהמלאי';
      }
    }

    optionSelects.forEach(function (s) { s.addEventListener('change', updatePDP); });
    updatePDP();

    // Mobile bar ATC → submit main form
    var barAtc = bar && bar.querySelector('[data-pdp-bar-atc]');
    if (barAtc && form) {
      barAtc.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    // Show mobile bar after scrolling past the main add-to-cart
    if (bar && atc) {
      var barIO = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -120px 0px' });
      barIO.observe(atc);
    }
  }
})();
